<svelte:head>
  <title>Travel Grant - PGConf.dev 2026</title>
  <meta
    name="description"
    content="The Travel Grant programs seeks to make PGConf.dev attendance affordable for those who can't easily pay for travel."
  />
</svelte:head>

<h1>Travel Grant Program</h1>

<p>
  The travel grant program is now closed. All available travel grants have been
  disbursed.
</p>

<!--
<h1>Travel Grant Program</h1>

<p>
  This program seeks to make PGConf.dev attendance affordable for those who
  can’t easily pay to travel and attend. By default, grants includes a
  complimentary registration and a hotel room in the conference affiliated hotel
  block. In some circumstances, we may be able to subsidize flights.
</p>

<h2>Eligibility Criteria</h2>
<p>
  Grant recipients should be those whose employers can’t or won’t pay for them
  to attend and be find it financially difficult to attend without a travel
  grant. Grant recipients should fall into one of the following categories:
</p>
<ol>
  <li>Speakers with an accepted session</li>

  <li>
    People who play an important role in the community (e.g. maintainer of an
    important ecosystem project)
  </li>
  <li>
    People who play an important role in organizing the conference (e.g
    organizing committee member)
  </li>
  <li>
    People identified as up-and-coming hackers or community organizers who the
    community wants to sponsor and encourage to become more involved
  </li>
</ol>

<h2>Application</h2>
<p>
  Grant applicants should complete <a
    href="https://docs.google.com/forms/d/e/1FAIpQLSdg_VmprbcqMiWrWr8ocNQeVFq8BljHZG9fqoZ4BVlY9u8PgA/viewform"
    >this form</a
  >.
</p>
<h2>Rules</h2>
<p>
  Grant recipients must not include their company or employer on their badge or
  slides.
</p>
<h2>Selection Process</h2>
<p>
  After the conference <a href="/cfp">Call for Proposals</a> closes and speaker selection
  decisions are announced, the Travel Grant Committee will review applications and
  notify applicants of their decisions within one week. Grants will be awarded based
  on merit, up to the total travel grant budget. If funds remain after the initial
  round, additional applications will be considered on a rolling, first-come, first-served
  basis.
</p>
<p>The selection committee is made up of the following members:</p>
<ul>
  <li>Melanie Plageman</li>
  <li>Steve Singer</li>
  <li>Masahiko Sawada</li>
</ul>
-->
